module.exports = __webpack_public_path__ + "media/site_templates/www.tradesmennearme.com.au/images/about_us-51e87c8232bb404d2b7b0fa60e3b53f5.jpg";